import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import React from 'react'
import ParticlesBackground3 from '../particles/ParticlesBackground3'
import {
  Timeline,
  Container,
  YearContent,
  BodyContent,
  Section,
  Description,
 } from 'vertical-timeline-component-react';
 import Galaxy from '../../assets/images/galaxy.jpg'

 //https://github.com/Proskynete/vertical-timeline-component-react
 const customTheme = {
  yearColor: '#bf19e4',
  lineColor: '#bf19e4',
  dotColor: '#262626',
  borderDotColor: '#d0cdc4',
  titleColor: '#bf19e4',
  subtitleColor: '#FFFF',
  textColor: '#bf19e4',
 };

const Progress = ({done,experience}) => {
	const [style, setStyle] = React.useState({});
	
	setTimeout(() => {
		const newStyle = {
			opacity: 1,
			width: `${done}%`
		}
		
		setStyle(newStyle);
	}, 800);
	
	return (
		<div className="progress">
			<div className="progress-done" style={style}>
				{experience}
			</div>
		</div>
	)
}

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
    <ParticlesBackground3/>
      <div className="container about-page">
        <div className="text-zone2">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
              idx={15}
            />
          </h1>
          <br/>
          <h2>Why should you hire me?</h2>
          <p2>
            &nbsp; &nbsp; &nbsp; I am a very motivated individual that loves to learn software skills (BackEnd & FrontEnd) and grow as a developer.
            I have leadership skills, communication skills, and teaching skills from my past experiences as an Instructor in Technology and Martial Arts.
            Moreover, I thrive in developing projects in a group because of my adaptive/meticulous nature, consistent work ethic, and organization. On the Other Hand,
            I'm aiming to improve on my Over Critical Nature, Low Self Esteem/ Imposter Syndrome, and Shyness. 
          </p2>
          <h2>Top Attributes: </h2>
          <p2>
            Open Minded, Objective, Reliable, Serious, Disciplined, Reserved, Ambitious <br/>
          </p2>
          <h2>Achievements</h2>
          <p2>
            200+ STEM STudents Taught <br/>
            300+ TKD Students Taught <br/>
            3rd Degree Black Belt <br/>
            Fordham BoS Computer Science Graduate
          </p2>
        </div>

        <div className="right-zone2">
          <h2>Time Line</h2>
      <Timeline theme={customTheme} dateFormat='full'>
			<Container>
				<YearContent startDate='2018/08/31' currentYear />
				<BodyContent>
					<Section title='Qualcomm_Software_Automation_Developer'>
						<Description variant='subtitle' text='Python Developer and Unit Testing Hardware(using Linux). Specifically working on Valiant qranium.' />
					</Section>
					<Section title='Graduated_College'>
						<Description variant='subtitle' text='Graduate in 3.5 years with a 3.65 GPA with a Bachelor of Science from Fordham.' />
					</Section>
          <Section title='Fordham_Autograder_Internship'>
						<Description variant='subtitle' text='Developed data structure labs that tested the system’s ability to handle/check errors such as memory leaks, syntax errors, word count etc. ' />
					</Section>
					<Section title='Start_College_&_Finish_High_School'>
						<Description variant='subtitle' text='Decided to Major in Computer Science due to my experience of Computer Science in High School. Courses such as C++ and AP JAVA helped me decide.' />
					</Section>
        </BodyContent>
			</Container>
      <Container>
      <YearContent startDate='2014/08/31' endDate='2018' />
      </Container>
		</Timeline>
    <h2>Goals</h2>
          <p2>
            1. I plan to make this website more mobile friendly. <br/>
            2. Look for a Full Time remote Software developer role <br/>
            3. Learn more Computer Science languages
          </p2>
        </div>
         {/*
        <div className="right-zone3">
          <h2> Attributes: </h2>
          <br/>
          <p3>
           - Open Minded<br/>
           - Objective <br/>
           - Loyal to Family<br/>
           - Reliable <br/>
           - Serious <br/>           
           - Understanding <br/>
           - Disciplined <br/>
           - Reserved <br/>
           - Ambitious <br/>
           - Orderly <br/>

          </p3>
        </div>
        <div className="ach_card1">
          200+ STEM Students Taught
          </div>
          <div className="ach_card2">
          300+ TKD Students Taught
          </div>
          <div className="ach_card3">
          3rd Degree Black Belt
          </div>
        */}
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
